import { IonButton, IonIcon } from '@ionic/react';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import styled from 'styled-components';

import InputField, { Props as InputProps } from './InputField';

const PasswordContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  width: 100%;
`;

const PasswordButton = styled(IonButton)`
  --padding-start: 0;
  --padding-end: 0;
  && {
    margin: 0;
  }
`;

const Password = ({ name, ...field }: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <PasswordContainer>
      <InputField
        type={showPassword ? 'text' : 'password'}
        {...field}
        role="textbox"
        aria-label={name}
      />
      <PasswordButton
        role="button"
        aria-label="Toggle Password"
        fill="clear"
        color="dark"
        // skipcq: JS-0417
        onClick={() => setShowPassword(prev => !prev)}
      >
        {showPassword && <IonIcon icon={eyeOutline} />}
        {!showPassword && <IonIcon icon={eyeOffOutline} />}
      </PasswordButton>
    </PasswordContainer>
  );
};

export default Password;
